export const environments = {
  production: 'production',
  development: 'development',
}
